;(function() {
  'use strict'

  angular.module('app.core').component('channelTagQuotas', {
    controller: Controller,
    templateUrl: 'channel-tag-quotas.html',
    bindings: {
      channel: '<',
      survey: '<',
      onSave: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.turnOff = turnOff

    function turnOff() {
      ctrl.channel.tagQuotasEnabled = false
    }
  }
})()
